<!--  -->
<template>
  <div id="Home">
      <div class="reverse pointer" @click="clickReverse"></div>
      <div class="carBg">
        <div class="batter">
          <div class="batteryFront">
            <div class="batterBox" v-for="(item,index) in batteryGroup[curReverse]" :key="index" :class="item.batteryId==curBatteryId?'select':''" @click="changeBattery(item,index)">
              <div class="point" v-if="item.batteryId==curBatteryId">
                <div class="inner flex align-center flex-direction">
                  <div class="title text-xsss margin-top-13 padding-bottom-8">{{item.batteryNumber}}电池箱</div>
                  <div class="code text-12 margin-top-13 padding-bottom-8">编码：{{item.batteryId}}</div>
                  <div class="point3 flex align-center justify-center" @click.stop="jumpToBatteryBox">进入电池箱<img src="@/assets/images/site/arrow_small.png"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="batterBox" v-for="(item,index) in batteryGroup[curReverse]" :key="index" :class="(item.batteryId==curBatteryId)&&(!item.temperature||item.status*1===0||item.status*1===4)?'select red':item.batteryId==curBatteryId?'select':''">
              <div class="batteryImg" :class="!item.temperature||item.status*1===0||item.status*1===4?'batteryRed':''"></div>
            </div>
          </div>
          
        </div>
      </div>
      <BatteryCompartment :selectBattery="currentIndex" :batteryList="batteryList" @changeParentIndex="changeParentIndex"/>

  </div>
</template>

<script>
import BatteryCompartment from "@/views/batteryHolder/batteryCompartment.vue";



  export default {
    name: 'home',
    components: {
      BatteryCompartment
    },
    props: {
      batteryList: {
        type: Array,
        default: () => ([])
      },
      vehicleClassification: {
        type: String,
        default: () => ("")
      },
    },
    watch: {
      batteryList(newValue, oldValue) {  
        
        if(newValue){
          let _this = this;
          this.batteryGroup = group(newValue,8)||[];
          this.reverseList = this.batteryGroup.map((item,index)=>index);
          this.batteryGroup.forEach((item,index)=>{
            item.forEach((i,idx)=>{
              if(_this.curBatteryId ==i.batteryId){
                this.curReverse = index;
              }
            })
          })
          newValue.map((item,index) => {
            if(this.curBatteryId ==item.batteryId){
              this.currentIndex = index;
              // this.curReverse = this.currentIndex%8
            }
          })
        }
      } 
    },
    data() {
      return {
        currentIndex : 0,//当前选中
        curBatteryId:'',
        batteryGroup:'',//分组
        reverseList:'',//切换数组
        curReverse:0,
      }
    },
    mounted() {
      this.curBatteryId = this.$route.query&&this.$route.query.batteryId;
    },
    methods: {
      //点击切换
      clickReverse(){
        let maxLength = this.batteryGroup.length;
        if(this.curReverse<maxLength-1){
          this.curReverse++;
        }else{
          this.curReverse=0;
        }
      },
      changeBattery(item,index){
        if(index!=this.currentIndex){
          this.currentIndex = index;
          //事件公交总线

          this.$router.replace({
            path:window.location.href.indexOf('pcbatteryHolder')>-1? '/pcbatteryHolder':'/batteryHolder',
            query: {
              batteryId:item.batteryId,
              stationId: this.$route.query.stationId,
              chargeWarehouseId:this.$route.query.chargingWarehouseNumber
            }
          })

          // if(window.location.href.indexOf('batteryHolder')>-1){
          //   //TODO:暂时方案，刷新页面
          //   this.$router.go(0);
          // }

        }
      },
      //子组件触发 修改父组件数据
      changeParentIndex(index){
        this.currentIndex = index;
      },
      // 跳转到电池仓页面
      jumpToBatteryBox(){
        //query-路由传参
        //当前电池点击数据
        let currentData = this.batteryList[this.currentIndex];
        if(window.location.href.indexOf('pcbatteryHolder')>-1){
          this.$router.push({
              path: '/pcbatteryBox',
              query: {
                batteryId:currentData.batteryId,
                equipNo:currentData.equipNo,
                stationId:this.$route.query.stationId,
                vehicleClassification:this.vehicleClassification=="乘用车"?0:1
              }
          })
        } else {
          this.$router.push({
              path: '/batteryBox',
              query: {
                batteryId:currentData.batteryId,
                equipNo:currentData.equipNo,
                stationId:this.$route.query.stationId,
                vehicleClassification:this.vehicleClassification=="乘用车"?0:1
              }
          })
        }
        // 0  乘用车  1 商用车
        // if(this.vehicleClassification=="乘用车"){
        //   this.$router.push({
        //     path: '/batteryBag',
        //     query: {}
        //   })
        // } else {
        //   this.$router.push({
        //     path: '/batteryBox',
        //     query: {
        //       batteryId:currentData.batteryId,
        //       equipNo:currentData.equipNo,
        //     }
        //   })
        // }
        
      }
    },
  }
function group(array, subGroupLength) {
  let index = 0;
  let newArray = [];
  while(index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength));
  }
  return newArray;
}

</script>
<style lang="scss" scoped>
$green-text:#49FFF9;

// 电池遍历
$gutter-width: 13px;
$array: (1,2, 3, 4, 5, 6, 7, 8);

  .green-text{
    color:$green-text;
  }
  #Home {
    width: 100%;
    height: 100%;
    position: relative;
    min-width: 2708px;
    background:url('~@/assets/images/site/bg.png');
    background-size: 100% 100%;
  }
  .carOuter{
    width:966px;
    height:653px;
    position: relative;
    top:10%;
    left:20%;
    overflow-x: scroll;
  }
  .carBg{
    width:966px;
    height:653px;
    position: relative;
    top:10%;
    left:50%;
    transform: translateX(-50%);
    background:url('~@/assets/images/battery/battery_holder.png');
    background-size: 100% 100%;
    .batter{
      // margin-left:35px;
      // margin-right:35px;
      position:relative;
      padding: 0 35px;
      .batteryFront{
        position:absolute;
        bottom: -66px;
        left: 0;
        width:923px;
        height:426px;
        background:url('~@/assets/images/battery/battery_front.png') left bottom no-repeat;
        background-size: 100% 100%;
        padding: 0 35px;
        display: flex;
        flex: 1;
        z-index: 9999;
        &>div {
          width: 105px;
          height: 198px;
          @each $i in $array {
          &:nth-child( #{$i} ) {
            margin-top: (55 + $i * $gutter-width);
          }
        }
        }
        label {
          display: inline-block;
          height: 100%;
        }
      }
      .batterBox{
        width:105px;
        height:198px;
        position:relative;
        .batteryImg{
          width:105px;
          height:198px;
          background:url('~@/assets/images/battery/battery_box.png');
          background-size:100% 100%;
          &.batteryRed{
            background:url('~@/assets/images/battery/red_box.png');
            background-size:100% 100%;
          }
        }
        .point{
          display:none;
        }
        &.select{
          .batteryImg{
            background:url('~@/assets/images/battery/battery_box_select.png');
            background-size:100% 100%;
            &.batteryRed{
              background:url('~@/assets/images/battery/red_box_sel.png');
              background-size:100% 100%;
            }
          }
          
          .point{
            display:block;
            position:absolute;
            width:312px;
            height:171px;
            background:url('~@/assets/images/battery/battery_point.png');
            background-size: cover;
            top:-70%;
            right:40%;
            z-index:100;
            .inner{
              width:220px;
              height:163px;
              .title{
                border-bottom: 1px solid #3DBCC1;
              }
            }
          }
        }
        @each $i in $array {
          &:nth-child( #{$i} ) {
            margin-top: (285 + $i * $gutter-width);
          }
        }
      }
    }
    
  }
  .point3{
    background: #00BAB8;
    border-radius: 2px;
    font-size: 18px;
    font-weight:500;
    padding:8px 13px;
    display: inline;
    img{
      width:16px;
      height:16px;
      margin-left:5px;
    }
  }
  .DS-font{
    font-family:'DS-Digital-Bold'
  }

  .reverse{
    background:url('~@/assets/images/battery/reverse.png');
    background-size:100% 100%;
    width:60px;
    height:60px;
    position: absolute;
    right:20%;
    top:0%;
    z-index:1000;
  }

</style>